import {
  LicenseCode,
  LicenseCodeDisplayName,
} from '@account-users/account/models/LicenseCode';
import { LICENSES_WITH_ICONS } from '@account-users/account/models/LicensePackage';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-account-package',
  templateUrl: './account-package.component.html',
  styleUrls: ['./account-package.component.scss'],
})
export class AccountPackageComponent {
  @Input() package: string;
  @Input() innerId = '';
  @Input() selected = false;
  @Input() licenses = [];

  LicenseCodeDisplayName = LicenseCodeDisplayName;

  constructor() {}

  hasIcon(tool: LicenseCode) {
    return LICENSES_WITH_ICONS.includes(tool);
  }
}
